<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12 text-center">
               <!-- {{year}} ©  Indore Municipal Corporation. -->
            </div>
        </div>
    </div>
</footer>